var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { GLASS_BREAKAGE_PERSONAL_PROPERTY_COUNT_CHOICES, GLASS_BREAKAGE_TRAD_KEYS, GLASS_BREAKAGE_PERSONAL_PROPERTY_DAMAGES_COUNT_ANSWERS, } from '@declaration/constants/glassBreakageDamageConstants';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
let GlassBreakagePersonalPropertyDamagesCountQuestion = class GlassBreakagePersonalPropertyDamagesCountQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.isSaving = false;
        this.typeOfDamages = '';
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get maxCount() {
        const value = this.setting('bdgPersonalPropertiesCountThresholdBeforeExpertise');
        return value ? parseInt(value) : 1;
    }
    get panelTitle() {
        return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['personal-property-damages-count-title']);
    }
    get sidebarTitle() {
        const key = GLASS_BREAKAGE_TRAD_KEYS['personal-property-damages-count-sidebar_title'];
        return key && this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get choices() {
        return GLASS_BREAKAGE_PERSONAL_PROPERTY_COUNT_CHOICES.map((choice) => {
            return {
                value: choice.value,
                label: this.$tc(choice.tradKey, this.maxCount, { count: this.maxCount }),
            };
        });
    }
    get selectedValue() {
        if (this.qualification.personalPropertiesCountAboveThreshold === null) {
            return null;
        }
        return this.qualification.personalPropertiesCountAboveThreshold;
    }
    get answer() {
        if (this.qualification.personalPropertiesCountAboveThreshold === null) {
            return null;
        }
        return this.qualification.personalPropertiesCountAboveThreshold
            ? this.$tc(GLASS_BREAKAGE_PERSONAL_PROPERTY_DAMAGES_COUNT_ANSWERS['more-than-threshold'], this.maxCount, { count: this.maxCount })
            : this.$tc(GLASS_BREAKAGE_PERSONAL_PROPERTY_DAMAGES_COUNT_ANSWERS['threshold-or-less'], this.maxCount, { count: this.maxCount });
    }
    get typeTrigram() {
        var _a;
        return (_a = this.claimTypeTrigram) !== null && _a !== void 0 ? _a : undefined;
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink, this.typeTrigram);
    }
    get showHelpLink() {
        var _a, _b, _c, _d;
        if (this.hideHelpLink &&
            ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.glassBreakagePersonalPropertyDamagesCount) === null || _d === void 0 ? void 0 : _d.showHelpLink) === false) {
            return false;
        }
        return true;
    }
    async onUpdate(personalPropertiesCountAboveThreshold) {
        await this.updateAndSaveGlassBreakageDamageQualification({
            qualificationPayload: { personalPropertiesCountAboveThreshold },
            step: this.step,
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], GlassBreakagePersonalPropertyDamagesCountQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    claim.State('claimTypeTrigram')
], GlassBreakagePersonalPropertyDamagesCountQuestion.prototype, "claimTypeTrigram", void 0);
__decorate([
    qualification.State('qualification')
], GlassBreakagePersonalPropertyDamagesCountQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], GlassBreakagePersonalPropertyDamagesCountQuestion.prototype, "updateGlassBreakageDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], GlassBreakagePersonalPropertyDamagesCountQuestion.prototype, "updateAndSaveGlassBreakageDamageQualification", void 0);
__decorate([
    settings.Getter('setting')
], GlassBreakagePersonalPropertyDamagesCountQuestion.prototype, "setting", void 0);
GlassBreakagePersonalPropertyDamagesCountQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], GlassBreakagePersonalPropertyDamagesCountQuestion);
export default GlassBreakagePersonalPropertyDamagesCountQuestion;
